module.exports = __webpack_public_path__ + "static/media/toggle-open.52953e37.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/toggle-open.svg
// module id = 421
// module chunks = 0